















import AccountSettings from '@/mixins/accountSettings.mixin';
import { Component, Mixins } from 'vue-property-decorator';
import { ScreenText } from '@/lang/ScreenText';

@Component
export default class LoginRightIllustration extends Mixins(AccountSettings) {
  public screenText = new ScreenText();
}
